import { TOPICS_ACTIONS } from '../actions/topicsActions';

const initialState = {
    data: [],
    loading: false,
    error: null,
    totalItems: 0,
    filters: {
        page: 1,
        limit: 10,
        search: '',
        category: null,
        fromDate: null,
        toDate: null,
        has_contributions: null
    }
};

const topicsReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOPICS_ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case TOPICS_ACTIONS.SET_DATA:
            return {
                ...state,
                data: action.payload.data,
                totalItems: action.payload.totalItems,
                error: null
            };

        case TOPICS_ACTIONS.SET_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };

        case TOPICS_ACTIONS.SET_SEARCH:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    search: action.payload
                }
            };

        case TOPICS_ACTIONS.SET_PAGE:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    page: action.payload
                }
            };

        case TOPICS_ACTIONS.SET_PAGE_SIZE:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    limit: action.payload,
                    page: 1 // Reset to first page when changing page size
                }
            };

        case TOPICS_ACTIONS.SET_CATEGORY_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    category: action.payload,
                    page: 1 // Reset to first page when changing category
                }
            };

        case TOPICS_ACTIONS.SET_DATE_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    fromDate: action.payload.fromDate,
                    toDate: action.payload.toDate,
                    page: 1 // Reset to first page when changing date filter
                }
            };

        case TOPICS_ACTIONS.CLEAR_FILTERS:
            return {
                ...state,
                filters: {
                    ...initialState.filters,
                    limit: state.filters.limit // Keep the current page size
                }
            };

        case TOPICS_ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case TOPICS_ACTIONS.RESET_STATE:
            return initialState;

        default:
            return state;
    }
};

export default topicsReducer;